import React, { Fragment } from 'react';
import { StaticQuery } from 'gatsby';
import Typography from '@material-ui/core/Typography';
import Img from "gatsby-image";
import { withStyles } from '@material-ui/core';
import { SocialIcon } from 'react-social-icons';

const styles = theme => ({
  picture: {
    width: '300px',
    margin: 'auto'
  },
  marginRight: {
    marginRight: '40px'
  }
});

const Header = ({ classes }) => {
  return (
    <StaticQuery
      query={graphql`
      query HeadingQuery {
        dataJson {
          developer {
            name
            role
            smallImage: image {
              childImageSharp {
                sizes(maxWidth: 1240 ) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    `}
      render={
        (data) => {
          const { name, role, smallImage } = data.dataJson.developer;
          return (
            <Fragment>
              <Img outerWrapperClassName={classes.picture} sizes={smallImage.childImageSharp.sizes} />
              <Typography variant="display3">
                {name}
              </Typography>
              <Typography variant="subheading" gutterBottom>
                {role}
              </Typography>
              <div>
                <SocialIcon url="https://www.linkedin.com/in/zhengyutay/" className={classes.marginRight} style={{ height: 50, width: 50 }} />
                <SocialIcon url="https://github.com/ZhengYuTay" style={{ height: 50, width: 50 }} />
              </div>
            </Fragment>
          );
        }}
    />
  );
};

export default withStyles(styles)(Header);